import React, { useEffect, useState } from "react";
import "./idcard.scss";
import logo from "../../assets/image/logo-amospa.svg";
import defaultImage from "../../assets/image/Default-User.png";
import emailIcon from "../../assets/icon-white/mail.svg";
import phoneIcon from "../../assets/icon-white/phone.svg";
import editIcon from "../../assets/image/edit.svg";
import deleteIcon from "../../assets/image/sampah.svg";
import { Link, useParams } from "react-router-dom";
import axios from "axios";

function Idcard() {
  const { id } = useParams();
  const [data, setData] = useState();
  const [classShowAction, setclassShowAction] = useState();
  const idStaff = window.localStorage.getItem("dataLogin");

  const getData = async () => {
    const result = await axios.get(`https://mobile.amospa.com/staff/${id}`);
    setData(result.data.data);
  };

  const handleAction = () => {
    idStaff
      ? setclassShowAction("action-show")
      : setclassShowAction("action-none");
  };

  useEffect(() => {
    getData();
    handleAction();
  }, [classShowAction]);
  return (
    <div className="wrapper-id-card mt-1">
      <div className="id-card">
        <div className="header">
          <div className="idcard-opacity">
            <img src={logo} alt="" />
          </div>
        </div>
        <div className="footer">
          <div className="wrapper-img-idcard">
            <img src={data ? data[0].image : defaultImage} alt="" />
          </div>
          <h5 className="mt-2 fw-bold">{data ? data[0].name : "Name Staff"}</h5>
          <div className="idcard-contact mt-2">
            <p>
              <span>
                <img src={emailIcon} alt="" />
              </span>
              {data ? data[0].email : "Email Staff"}
            </p>
            <p className="mt-1">
              <span>
                <img src={phoneIcon} alt="" />
              </span>
              {data ? data[0].phone : "Phone Staff"}
            </p>
          </div>
          <h6 className="mt-4 fw-bold">HEAD OFFICE</h6>
          <p className="alamat">
            Jl. Pantai Batu Bolong N0 69 Canggu, Bali 80361 Indonesia
          </p>
          <div className={classShowAction}>
            <Link to={"/homepage/staff-edit"}>
              <div className="wrapper-edit-icon">
                <img src={editIcon} alt="" />
              </div>
            </Link>
            <div className="wrapper-delete-icon">
              <img src={deleteIcon} alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Idcard;
